/* Four copper rivets pinned to the corners of a photo frame. */
export default function RivetCorners({ inset = "8px", className = "" }) {
    return (
        <div aria-hidden="true" className={`pointer-events-none absolute z-10 ${className}`} style={{ inset }}>
            {["left-0 top-0", "right-0 top-0", "bottom-0 left-0", "bottom-0 right-0"].map((pos) => (
                <span
                    key={pos}
                    className={`rivet absolute h-3 w-3 rounded-full opacity-80 transition-transform duration-300 group-hover:scale-125 ${pos}`}
                />
            ))}
        </div>
    );
}
